import React, { useEffect, useState } from 'react';
import style from '@theme/js/components/main/SmsVerification/index.scss';
import { PHONE_PREFIX } from '@theme/js/components/main/SmsVerification/constants';
import { useTranslations } from '@core/js/hooks/i18n';
import { SmsVerificationStepType } from '@theme/js/components/main/SmsVerification';
import { useUserSelector } from '@core/js/store/hooks';
import { prop } from 'ramda';
import Form from '@core/js/components/common/Form';
import { useUpdatePlayerInfo } from '@core/js/hooks/socket';
import { useFetchUserDetails } from '@core/js/hooks/user';
import { useValidationConfig } from '@theme/js/components/main/SmsVerification/hooks/useValidationConfig';
import { Input } from '@core/js/components/common/Fields/Input/Input';

type FormRenderProps = {
    handleSubmit: () => void
}

const ChangeNumberStep = React.memo(({ setStep, prevStep, onClose }: SmsVerificationStepType) => {
    const [number, setNumber] = useState('');
    const [isNumberChanged, setIsNumberChanged] = useState(false);
    const { cellphone } = useUserSelector(prop('userDetails'));
    const t = useTranslations('playtech.mobile.system.verification.changeNumber.');
    const updatePlayerInfo = useUpdatePlayerInfo();
    const fetchUserDetails = useFetchUserDetails();
    const validationConfig = useValidationConfig({ t, field: 'cellphone' });

    useEffect(() => {
        // Move to the next page if phone changed successfully
        if (PHONE_PREFIX + number === cellphone && isNumberChanged) {
            setStep?.(prevStep?.current as string);
        }
    }, [cellphone, number, setStep, prevStep, onClose, isNumberChanged]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumber(e.target.value);
    };

    const handleSubmitClick = async () => {
        setIsNumberChanged(true);
        await updatePlayerInfo({ dataMap: { cellphone: PHONE_PREFIX + number } });
        await fetchUserDetails();
    };

    return (
        <Form onSubmit={handleSubmitClick}
            validationConfig={validationConfig}
            render={({ handleSubmit }: FormRenderProps) => (
            <form onSubmit={handleSubmit}>
                <div className={`${style.icon} ${style.mobileIcon}`}></div>
                <div className={style.message}>{t('message')}</div>
                <div className={style.description}>{t('description')}</div>
                <div className={style.nubmerContainer}>
                    <div className={style.numberPrefix}>{PHONE_PREFIX}</div>
                    <Input
                        type="number"
                        name="cellphone"
                        onChange={handleInputChange}
                        value={number}
                        className={style.formInput}
                        classNames={{ content: style.formInputContent, error: style.error }}
                    />
                </div>
                <button type="submit" className={style.verificationButton}>
                    {t('submit')}
                </button>
            </form>
        )}/>
    );
});

export default ChangeNumberStep;
